/**
 * Workflow category → generation section route.
 *
 * Used by the gallery "Recreate" action to send the user to the section that
 * actually hosts the workflow. Extracted from `GalleryImageCard` so the mapping
 * is testable without mounting the card, and so a new content type only has to
 * be added in one place.
 */

const CATEGORY_ROUTES: Record<string, string> = {
  Video: '/video',
  Voice: '/audio',
  Text: '/text',
  '3D': '/3d',
  Image: '/image',
};

/** Route for a workflow category; unknown/absent categories fall back to `/image`. */
export function resolveRecreateRoute(category?: string | null): string {
  if (!category) return '/image';
  return CATEGORY_ROUTES[category] || '/image';
}
